<template>
  <el-container>
    <el-main>
      <div style="margin-bottom: 30px">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item class="item_font">个人设置</el-breadcrumb-item>
          <el-breadcrumb-item
            ><span class="item_font">使用参数设置</span></el-breadcrumb-item
          >
        </el-breadcrumb>
      </div>
      <div style="background-color: #f8f8f8">
        <!-- 常规设置 -->
        <el-table
          :data="generalLst"
          style="width: 100%"
          :cell-style="cellStyle1"
          :header-cell-style="headerStyle1"
          stripe
          class="item_font"
          :row-class-name="tableRowClassName1"
        >
          <el-table-column width="300" prop="name" label="常规" fixed>
            <template slot-scope="scope">
              <span class="tipBeforeStyle">{{ scope.row.name }} </span>
            </template>
          </el-table-column>

          <el-table-column>
            <template slot-scope="scope">
              <template v-if="generalLst[scope.$index].jsonParamList">
                <div v-for="(item, index) in generalLst" v-bind:key="index">
                  <template
                    v-if="
                      item.jsonParamList &&
                      scope.$index == index && (
                      item.name == '快捷回复默认全部展开' ||
                      item.name == '快捷回复预览开关' ||
                      item.name == '按会话展示'
                      )"
                    width="50"
                  >
                    <div v-if="item.isClose !== 1">
                      <el-switch
                        v-model="item.jsonParamList[0].value"
                        active-color="#13ce66"
                        inactive-color="#bfbfbf"
                        active-text="开启"
                        inactive-text="关闭"
                        @change="
                          onOff(item.id, item.name, item.jsonParamList[0].value)
                        "
                      ></el-switch>
                    </div>
                  </template>
                </div>
              </template>
              <template v-if="generalLst[scope.$index].name == '已离开客户列表，展示最新离开人数'">
                <span style="margin-right: 7px; color: #909090">{{
                  generalLst[scope.$index].remark
                }}</span>
                <el-radio-group
                  v-model="radio"
                  @change="show(scope.$index)"
                  v-if="generalLst[scope.$index].isClose !== 1"
                >
                  <el-radio
                    class="item_font"
                    :label="lab1.value"
                    v-for="(lab1, ind1) in generalLst[scope.$index]
                      .jsonParamList"
                    v-bind:key="ind1"
                    >{{ lab1.label }}</el-radio
                  >
                </el-radio-group>
                <el-radio-group
                  v-model="radio"
                  @change="show(scope.$index)"
                  v-if="generalLst[scope.$index].isClose === 1"
                >
                  <el-radio
                    disabled
                    :label="lab1.value"
                    v-for="(lab1, ind1) in generalLst[scope.$index]
                      .jsonParamList"
                    v-bind:key="ind1"
                    >{{ lab1.label }}</el-radio
                  >
                </el-radio-group>
              </template>
              <template v-if="generalLst[scope.$index].name == '回复框智能联想数据源来自'">
                <el-checkbox-group
                  v-model="checkList"
                  @change="source(scope.$index)"
                  v-if="generalLst[scope.$index].isClose !== 1"
                >
                  <el-checkbox
                    :label="lab2.label"
                    v-for="(lab2, ind2) in generalLst[scope.$index]
                      .jsonParamList"
                    v-bind:key="ind2"
                  ></el-checkbox>
                </el-checkbox-group>
                <el-checkbox-group
                  v-model="checkList"
                  @change="source(scope.$index)"
                  v-if="generalLst[scope.$index].isClose === 1"
                >
                  <el-checkbox
                    disabled
                    :label="lab2.label"
                    v-for="(lab2, ind2) in generalLst[scope.$index]
                      .jsonParamList"
                    v-bind:key="ind2"
                  ></el-checkbox>
                </el-checkbox-group>
              </template>
              <template v-if="generalLst[scope.$index].name == '字体设置'">
                <span
                  style="margin-right: 7px; color: #909090"
                  v-if="generalLst[scope.$index].isClose !== 1"
                  >字体默认正常大小
                </span>

                <el-radio-group
                  v-model="font"
                  @change="showFont(scope.$index)"
                  v-if="generalLst[scope.$index].isClose !== 1"
                >
                  <el-radio
                    :label="lab3.label"
                    v-for="(lab3, ind3) in generalLst[scope.$index]
                      .jsonParamList"
                    v-bind:key="ind3"
                  >
                  </el-radio>
                </el-radio-group>
              </template>
              <template v-if="generalLst[scope.$index].name == '音量设置'">
                <span
                  style="margin-right: 7px; color: #909090"
                  v-if="generalLst[scope.$index].isClose !== 1"
                  >{{ scope.row.remark }}
                </span>

                <el-radio-group
                  v-model="volume"
                  @change="changeVolume(scope.$index)"
                  v-if="scope.row.isClose !== 1"
                >
                  <el-radio
                    :label="lab3.label"
                    v-for="(lab3, ind3) in scope.row.jsonParamList"
                    v-bind:key="ind3"
                  >
                  </el-radio>
                </el-radio-group>
              </template>

              <template v-if="generalLst[scope.$index].name == '快捷回复位置设置'">
                <span
                  style="margin-right: 7px; color: #909090"
                  v-if="generalLst[scope.$index].isClose !== 1"
                  >{{ scope.row.remark }}
                </span>

                <el-radio-group
                  v-model="position"
                  @change="changePosition( scope.row.id)"
                  v-if="scope.row.isClose !== 1"
                >
                  <el-radio
                    :label="lab3.label"
                    v-for="(lab3, ind3) in scope.row.jsonParamList"
                    v-bind:key="ind3"
                  >
                  </el-radio>
                </el-radio-group>
              </template>

      
            </template>
          </el-table-column>
        </el-table>

        <!-- 提示设置 -->
        <div style="margin-top: 14px">
          <el-table
            :data="generalLst"
            style="width: 100%"
            :cell-style="cellStyle1"
            :header-cell-style="headerStyle1"
            :row-class-name="tableRowClassName2"
            stripe
          >
            <el-table-column width="300" prop="name" label="提示设置" fixed>
              <template slot-scope="scope">
                <template v-if="generalLst[scope.$index].name != '关键词提示'">
                  <span class="tipBeforeStyle">{{
                    generalLst[scope.$index].name
                  }}</span>
                </template>
                <template v-if="generalLst[scope.$index].name == '关键词提示'">
                  <span class="tipBeforeStyle">{{
                    generalLst[scope.$index].name
                  }}</span>
                  <div style="margin: 10px 0">
                    <el-button
                      type="primary"
                      style="background-color: #1577d2; margin-right: 14px"
                      size="mini"
                      @click="deleteKeys"
                      >编辑关键词</el-button
                    >
                  </div>
                  <div>
                    关键词：<span
                      style="color: #1577d2"
                      v-for="(item, index) in keyList"
                      :key="index"
                      >{{
                        index !== keyList.length - 1 ? item + "、" : item
                      }}</span
                    >
                  </div>
                </template>
              </template>
            </el-table-column>
            <el-table-column>
              <template slot-scope="scope">

                <template v-if="generalLst[scope.$index].name == '新消息提示'">
                  <div class="Rcell">
                    <div
                      v-for="(item, index) in generalLst[scope.$index]
                        .jsonParamList"
                      class="rdo"
                      v-bind:key="index"
                    >
                      <!-- 新消息提示-->
                      <div style="margin-left: 10px">
                        <el-radio
                          v-model="cueRadio1.name"
                          @change="
                            check(cueRadio1.name, item.value, generalLst[scope.$index].id, generalLst[scope.$index].name)
                          "
                          :label="item.label"
                          style="margin-right: 5px"
                          :disabled="
                            !cueRadio1.state && item.label === '自定义'
                          "
                          >{{ item.label }}</el-radio
                        >
                        <audio
                          @canplay="playing()"
                          @ended="ended()"
                          v-if="item.label !== '无声'"
                          v-show="audio"
                          :id="item.value"
                          :src="item.value"
                          :ref="item.value"
                        ></audio>
                        <i
                          class="el-icon-video-play"
                          v-show="
                            item.label !== '无声' &&
                            cueRadio1.index !== index &&
                            item.value !== ''
                          "
                          style="margin: 0 5px; color: #636363"
                          @click="player('cue1', item.value, index)"
                        ></i>
                        <i
                          class="el-icon-video-pause"
                          v-show="
                            item.label !== '无声' &&
                            cueRadio1.index === index &&
                            item.value !== ''
                          "
                          style="margin: 0 5px; color: #636363"
                          @click="player('cue1', item.value, index)"
                        ></i>
                      </div>
                    </div>

                    <div>
                      <el-upload
                        class="upload-demo"
                        ref="upload"
                        :headers="myHeaders"
                        :action="urlPath"
                        accept=".mp3"
                        :show-file-list="false"
                        :before-upload="beforeUpload"
                        :on-success="
                          (res, file) => {
                            upSuccess(
                              generalLst[scope.$index].jsonParamList[5],
                              generalLst[scope.$index].isClose,
                              scope.$index,
                              res,
                              file
                            );
                          }
                        "
                      >
                        <i
                          class="el-icon-edit"
                          v-if="cueRadio1.state === true"
                          style="margin-left: 12px"
                        ></i>
                        <i
                          class="el-icon-upload2"
                          v-if="cueRadio1.state === false"
                          style="margin-left: 12px"
                        ></i>
                      </el-upload>
                    </div>
                  </div>
                </template>
                
                <template v-if="generalLst[scope.$index].name == '关键词提示'">
                  <div
                    class="Rcell"
                    style="position: absolute; right: 10px; top: 14px"
                  >
                    <div
                      v-for="(item, index) in generalLst[scope.$index]
                        .jsonParamList"
                      class="rdo"
                      v-bind:key="index"
                    >
                      <!--  关键词提示-->
                      <div style="margin-left: 10px">
                        <el-radio
                          v-model="cueRadio3.name"
                          @change="
                            check(cueRadio3.name, item.value, generalLst[scope.$index].id, generalLst[scope.$index].name)
                          "
                          :label="item.label"
                          :disabled="
                            !cueRadio3.state && item.label === '自定义'
                          "
                          style="margin-right: 5px"
                          >{{ item.label }}</el-radio
                        >
                        <audio
                          @canplay="playing()"
                          @ended="ended()"
                          v-if="item.label !== '无声'"
                          v-show="audio"
                          :id="item.value"
                          :src="item.value"
                        ></audio>
                        <i
                          class="el-icon-video-play"
                          v-if="
                            item.label !== '无声' &&
                            cueRadio3.index !== index &&
                            item.value !== ''
                          "
                          style="margin: 0 5px; color: #636363"
                          @click="player('cue3', item.value, index)"
                        ></i>
                        <i
                          class="el-icon-video-pause"
                          v-if="
                            item.label !== '无声' &&
                            cueRadio3.index === index &&
                            item.value !== ''
                          "
                          style="margin: 0 5px; color: #636363"
                          @click="player('cue3', item.value, index)"
                        ></i>
                      </div>
                    </div>
                    <div>
                      <el-upload
                        class="upload-demo"
                        ref="upload"
                        :headers="myHeaders"
                        :action="urlPath"
                        accept=".mp3"
                        :show-file-list="false"
                        :before-upload="beforeUpload"
                        :on-success="
                          (res, file) => {
                            upSuccess(
                              generalLst[scope.$index].jsonParamList[5],
                              generalLst[scope.$index].isClose,
                              scope.$index,
                              res,
                              file
                            );
                          }
                        "
                      >
                        <i
                          class="el-icon-edit"
                          v-if="cueRadio3.state == true"
                          style="margin-left: 12px"
                        ></i>
                        <i
                          class="el-icon-upload2"
                          v-if="cueRadio3.state == false"
                          style="margin-left: 12px"
                        ></i>
                      </el-upload>
                    </div>
                  </div>
                </template> 
                <template v-if="generalLst[scope.$index].name == '转潜提示音'">
                  <div class="Rcell">
                    <div
                      v-for="(item, index) in generalLst[scope.$index]
                        .jsonParamList"
                      class="rdo"
                      v-bind:key="index"
                    >
                      <!--  新用户提示-->
                      <div style="margin-left: 10px">
                        <el-radio
                          v-model="cueRadio5.name"
                          @change="
                            check(cueRadio5.name, item.value, generalLst[scope.$index].id, generalLst[scope.$index].name)
                          "
                          :label="item.label"
                          :disabled="
                            !cueRadio5.state && item.label === '自定义'
                          "
                          style="margin-right: 5px"
                          >{{ item.label }}</el-radio
                        >

                        <audio
                          @canplay="playing()"
                          @ended="ended()"
                          v-if="item.label !== '无声'"
                          v-show="audio"
                          :id="item.value"
                          :src="item.value"
                        ></audio>
                        <i
                          class="el-icon-video-play"
                          v-if="
                            item.label !== '无声' &&
                            cueRadio5.index !== index &&
                            item.value !== ''
                          "
                          style="margin: 0 5px; color: #636363"
                          @click="player('cue5', item.value, index)"
                        ></i>
                        <i
                          class="el-icon-video-pause"
                          v-if="
                            item.label !== '无声' &&
                            cueRadio5.index === index &&
                            item.value !== ''
                          "
                          style="margin: 0 5px; color: #636363"
                          @click="player('cue5', item.value, index)"
                        ></i>
                      </div>
                    </div>
                    <div>
                      <el-upload
                        class="upload-demo"
                        ref="upload"
                        :headers="myHeaders"
                        :action="urlPath"
                        accept=".mp3"
                        :show-file-list="false"
                        :before-upload="beforeUpload"
                        :on-success="
                          (res, file) => {
                            upSuccess(
                              generalLst[scope.$index].jsonParamList[5],
                              generalLst[scope.$index].isClose,
                              scope.$index,
                              res,
                              file
                            );
                          }
                        "
                      >
                        <i
                          class="el-icon-edit"
                          v-if="cueRadio5.state == true"
                          style="margin-left: 12px"
                        ></i>
                        <i
                          class="el-icon-upload2"
                          v-if="cueRadio5.state == false"
                          style="margin-left: 12px"
                        ></i>
                      </el-upload>
                    </div>
                  </div>
                </template>
  
   
              <template v-if="generalLst[scope.$index].name == '进度提示音'">
                  <div class="Rcell">
                    <div
                      v-for="(item, index) in generalLst[scope.$index]
                        .jsonParamList"
                      class="rdo"
                      v-bind:key="index"
                    >
                      <!--  新用户提示-->
                      <div style="margin-left: 10px">
                        <el-radio
                          v-model="cueRadio6.name"
                          @change="
                            check(cueRadio6.name, item.value, generalLst[scope.$index].id, generalLst[scope.$index].name)
                          "
                          :label="item.label"
                          :disabled="
                            !cueRadio6.state && item.label === '自定义'
                          "
                          style="margin-right: 5px"
                          >{{ item.label }}</el-radio
                        >

                        <audio
                          @canplay="playing()"
                          @ended="ended()"
                          v-if="item.label !== '无声'"
                          v-show="audio"
                          :id="item.value"
                          :src="item.value"
                        ></audio>
                        <i
                          class="el-icon-video-play"
                          v-if="
                            item.label !== '无声' &&
                            cueRadio6.index !== index &&
                            item.value !== ''
                          "
                          style="margin: 0 5px; color: #636363"
                          @click="player('cue6', item.value, index)"
                        ></i>
                        <i
                          class="el-icon-video-pause"
                          v-if="
                            item.label !== '无声' &&
                            cueRadio6.index === index &&
                            item.value !== ''
                          "
                          style="margin: 0 5px; color: #636363"
                          @click="player('cue6', item.value, index)"
                        ></i>
                      </div>
                    </div>
                    <div>
                      <el-upload
                        class="upload-demo"
                        ref="upload"
                        :headers="myHeaders"
                        :action="urlPath"
                        accept=".mp3"
                        :show-file-list="false"
                        :before-upload="beforeUpload"
                        :on-success="
                          (res, file) => {
                            upSuccess(
                              generalLst[scope.$index].jsonParamList[5],
                              generalLst[scope.$index].isClose,
                              scope.$index,
                              res,
                              file
                            );
                          }
                        "
                      >
                        <i
                          class="el-icon-edit"
                          v-if="cueRadio6.state == true"
                          style="margin-left: 12px"
                        ></i>
                        <i
                          class="el-icon-upload2"
                          v-if="cueRadio6.state == false"
                          style="margin-left: 12px"
                        ></i>
                      </el-upload>
                    </div>
                  </div>
                </template>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div></div>
      <!-- 新增关键词 -->
      <el-dialog
        title="新增关键词"
        custom-class="el-dialog-crucial"
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        lock-scroll
        width="40%"
        @close="keyWordsDto.keyValue = ''"
      >
        <template slot="title">
          <!-- <span class="el-dialog__title"
            >{{ addOrEdit === "add" ? "新增" : "编辑" }}关键词</span
          > -->
          <span class="el-dialog__title">编辑关键词</span>
        </template>
        <span class="el-dialog__cue">输入需要提示的关键词（用空格隔开）</span>
        <el-input
          type="textarea"
          :autosize="{ minRows: 4 }"
          placeholder="请输入内容"
          v-model="keyWordsDto.keyValue"
        >
        </el-input>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false" size="mini"
            >取 消</el-button
          >
          <el-button
            type="primary"
            size="mini"
            style="background-color: #1577d2"
            @click="handleKeys(addOrEdit)"
            >确 定</el-button
          >
        </span>
      </el-dialog>
      <!-- 新消息提示 -->
      <div v-if="editSound == true">
        <el-dialog
          :title="title"
          :visible.sync="editSound"
          custom-class="dialog"
          :close-on-click-modal="false"
          :close-on-press-escape="false"
          width="30%"
          center
        >
          <!--  -->
          <div style="margin-bottom: 80px">
            <div style="margin-bottom: 10px">新消息提示</div>
            <div class="item">
              <div v-for="(item, index) in zanshiLst.lst1" :key="index">
                {{ item }}
                <image></image>
              </div>
            </div>
            <div
              slot="footer"
              class="dialog-footer"
              style="margin-top: 10px; float: right"
            >
              <el-button size="mini">删除</el-button>
              <el-button
                type="primary"
                @click="add(1, zanshiLst.type)"
                size="mini"
                >添加</el-button
              >
            </div>
          </div>
          <div>
            <div style="margin-bottom: 10px">新用户提示</div>
            <div class="item">
              <div v-for="(item, index) in zanshiLst.lst2" :key="index">
                {{ item }}
                <image></image>
              </div>
            </div>
            <div
              slot="footer"
              class="dialog-footer"
              style="margin-top: 10px; float: right"
            >
              <el-button size="mini">删除</el-button>
              <el-button
                type="primary"
                @click="add(2, zanshiLst.type)"
                size="mini"
                >添加</el-button
              >
            </div>
          </div>
          <div slot="footer" class="dialog-footer" style="margin-top: 50px">
            <el-button type="primary" @click="editSound = false"
              >确 定</el-button
            >
          </div>
        </el-dialog>
      </div>
      <!-- 新增音效 -->
      <div v-if="addSound == true">
        <el-dialog
          title="新增音效"
          :visible.sync="addSound"
          width="30%"
          :close-on-click-modal="false"
          :close-on-press-escape="false"
          center
        >
          <div style="margin: 0 auto; width: 180px">
            <el-form :model="form">
              <!-- <el-form-item label="音效标题:" label-width="73px">
								<el-input v-model="form.name" style="width: 220px;"></el-input>
							</el-form-item> -->
              <el-form-item label="音效文件:" label-width="73px"
                ><el-button type="text" style="width: 120px"
                  >点击上传音效文件</el-button
                ></el-form-item
              >
            </el-form>
          </div>
          <span slot="footer" class="dialog-footer"
            ><el-button type="primary" @click="addSound = false"
              >确 定</el-button
            ></span
          >
        </el-dialog>
      </div>
      <div v-if="addbg == true">
        <el-dialog
          title="新增闪烁背景"
          :visible.sync="addbg"
          width="30%"
          :close-on-click-modal="false"
          :close-on-press-escape="false"
          center
        >
          <div style="margin: 0 auto; width: 300px">
            <el-form :model="form">
              <!-- <el-form-item label="背景标题:" label-width="73px">
								<el-input v-model="form.name" style="width: 220px;"></el-input>
							</el-form-item> -->
              <el-form-item label="背景颜色:" label-width="73px">
                <el-select
                  v-model="bgvalue"
                  placeholder="请选择"
                  style="width: 220px"
                >
                  <el-option
                    label="· 红色"
                    value="1"
                    style="color: #ff6666"
                  ></el-option>
                  <el-option
                    label="· 紫色"
                    value="2"
                    style="color: #b05dc9"
                  ></el-option>
                  <el-option
                    label="· 黄色"
                    value="3"
                    style="color: #faad14"
                  ></el-option>
                  <el-option
                    label="· 棕色"
                    value="4"
                    style="color: #ab7762"
                  ></el-option>
                  <el-option
                    label="· 蓝色"
                    value="5"
                    style="color: #5a9cf8"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-form>
          </div>
          <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="save">确 定</el-button>
          </div>
        </el-dialog>
      </div>
    </el-main>
  </el-container>
</template>
<script>
export default {
  data() {
    return {
      routineData: [],
      textData: [
        {
          text: "新消息提示：",
        },
        {
          text: "新用户提示：",
        },
      ],
      radio: "全部",
      radio1: "1",
      radio2: "1",
      radio3: "1",
      radio4: "1",
      value0: true,
      value1: false,
      value2: false,
      value3: false,
      checkList: [],
      editSound: false,
      editBgcolor: false,
      generalLst: [],
      soundLst: [
        { id: "1", title: "无声" },
        { id: "2", title: "提示音1" },
        { id: "3", title: "提示音2" },
        { id: "4", title: "提示音3" },
        { id: "5", title: "提示音4" },
      ],
      colorLst: [],
      zanshiLst: {
        type: "",
        lst1: [],
        lst2: [],
      },
      title: "",
      addSound: false,
      addbg: false,
      soundInput: "",
      bgInput: "",
      bgvalue: "",
      state: "",
      state1: false,
      state2: false,
      state3: false,
      state4: false,
      form: {
        name: "",
      },
      fileList: [],
      zdyColor1: "#ffffff",
      zdyColor2: "#ffffff",
      realName: "",
      id: "",
      lst: [{ id: "" }],
      userLst: [],
      stateLst: [],
      setLst: [],
      selfId1: "",
      selfId2: "",
      myHeaders: { Authorization: localStorage.getItem("token") },
      audio: false,
      src1: "",
      src2: "",
      playFlag: false,
      urlPath:
        JSON.parse(localStorage.getItem("siteObj")).webUrl +
        "/manager/fileInfo/pass/upload",
      dealdata: true,
      audioID: "",
      font: "正常",
      volume: "正常",
      position: "右侧",
      audioState: false,
      audioIndex: "",
      audioIndex1: "",
      audioClick: false,
      // cueData: [],
      cueRadio1: {
        name: "无声",
        index: 0,
        state: false,
      },
      cueRadio2: {
        name: "无声",
        index: 0,
        state: false,
      },
      cueRadio3: {
        name: "无声",
        index: 0,
        state: false,
        valueId: "",
      },

      cueRadio4: {
        name: "无声",
        index: 0,
        state: false,
        valueId: "",
      },

      cueRadio5: {
        name: "无声",
        index: 0,
        state: false,
        valueId: "",
        id:0,
      },
      cueRadio6: {
        name: "无声",
        index: 0,
        state: false,
        valueId: "",
        id:0,
      },
      dialogVisible: false,
      keyWordsDto: {
        keyLists: [],
        keyValue: "",
      },
      keyList: [],
      addOrEdit: "add",
      keyMusic: "",
    };
  },
  mounted() {
    const account = JSON.parse(localStorage.getItem("account"));
    this.realName = account.realName;
    this.id = account.id;
    console.log("account", account);
    // console.log(localStorage.getItem('flickeraudiourl'),localStorage.getItem('newaudiourl'))
    this.allParameter();
    // this.userParameter();
    // this.selectSoundParameter();
    this.getKeys();
  },
  watch: {
    generalLst: function (newVal, oldVal) {
      console.log(newVal, oldVal);
      this.generalLst = newVal;
    },
    userLst: function (newVal, oldVal) {
      console.log(newVal, oldVal);
      this.userLst = newVal;
    },
    "keyWordsDto.keyLists": {
      handler(newVal) {
        this.keyWordsDto.keyLists = newVal;
      },
      deep: true,
    },
  },
  methods: {
    // deleteKeys() {
    //   this.dialogVisible = true;
    //   this.addOrEdit = "edit";
    //   this.keyList.forEach((item) => {
    //     this.keyWordsDto.keyValue += item + " ";
    //   });
    // },
    changeVolume(index) {
      this.dealdata = true;
      let value = "";
      if (this.volume === "静音") {
        value = "0";
      } else if (this.volume === "小") {
        value = "1";
      } else if (this.volume === "正常") {
        value = "2";
      } else if (this.volume === "大") {
        value = "3";
      } else if (this.volume === "特大") {
        value = "4";
      }
      this.setParameter(index + 1, value);
    },


    changePosition(id) {
      this.dealdata = true;
      let value = "";
      if (this.position === "左侧") {
        value = "0";
      } else if (this.position === "右侧") {
        value = "1";
      } 
      this.setParameter(id, value);
    },

    deleteKeys() {
      this.dialogVisible = true;
      this.addOrEdit = "add";
      this.keyList.forEach((item) => {
        this.keyWordsDto.keyValue += item + " ";
      });
    },
    async handleKeys() {
      var api;
      var payload;
      var keyValue;
      keyValue = this.keyWordsDto.keyValue.split(" ");
      for (let i = 0; i < keyValue.length; i++) {
        keyValue[i] = keyValue[i].replace(/\n/g, "");
      }
      console.log(keyValue);
      keyValue = keyValue.filter((item) => item !== "");
      keyValue = [...new Set(keyValue)];
      var notExist = true;
      console.log("关键词列表", this.keyWordsDto.keyLists, keyValue);
      if (this.addOrEdit === "add") {
        api = "/manager/keyWordMatch/add";
        console.log(notExist);
        payload = {
          keyWords: keyValue,
          valueId: this.keyMusic,
        };
        // if (this.keyWordsDto.keyValue === "") {
        //   this.$message.error("输入内容不能为空！");
        //   return;
        // } else {
        //   for (let j = 0; j < this.keyWordsDto.keyLists.length; j++) {
        //     if (
        //       keyValue.indexOf(this.keyWordsDto.keyLists[j].keywords) !== -1
        //     ) {
        //       notExist = false;
        //       break;
        //     }
        //   }
        //   if (notExist) {
        //     var temp = [...new Set([...keyValue, ...this.keyList])];
        //     api = "/manager/keyWordMatch/add";
        //     payload = {
        //       keyWords: temp,
        //       valueId: this.keyMusic,
        //     };
        //     this.getKeys();
        //   } else {
        //     this.$message.error("已有存在的关键词！");
        //     return;
        //   }
        // }
      } else {
        // 删除关键词
        var delKey = this.keyWordsDto.keyValue;
        delKey = delKey.split(" ");
        for (let i = 0; i < delKey.length; i++) {
          delKey[i] = delKey[i].replace(/\n/g, "");
        }
        delKey = delKey.filter((item) => item !== "");
        console.log("去掉空格：", delKey);
        api = "/manager/keyWordMatch/del";
        var tempDel2 = [];
        this.keyWordsDto.keyLists.forEach((item) => {
          if (delKey.indexOf(item.keywords) === -1) {
            console.log("匹配的关键词：", item);
            tempDel2.push(item.id);
          }
        });
        console.log("需要删除的列表:", tempDel2);
        payload = {
          ids: tempDel2.toString(),
        };
        // console.log(payload);
        // if (!payload.ids) {
        //   this.$message.error("关键词不存在，请重新输入！");
        //   return;
        // }
      }
      const response = await this.util.postRequest({
        url: api,
        method: "POST",
        data: payload,
      });
      if (response.resultCode === "10000") {
        this.$message.success("编辑关键词成功");
        // if (this.addOrEdit === "add") {
        //   this.$message.success("关键词添加成功!");
        // } else {
        //   this.$message.success("关键词删除成功!");
        // }
        this.dialogVisible = false;
        this.getKeys();
      } else {
        this.$message.error(response.desc);
      }
    },
    async getKeys() {
      var api = "/manager/keyWordMatch/select";
      const response = await this.util.postRequest({
        url: api,
        method: "POST",
        data: {},
      });
      if (response.resultCode === "10000") {
        this.keyWordsDto.keyLists = response.data;
      }
      var temp = [];
      response.data.forEach((item) => {
        temp.push(item.keywords);
      });
      this.keyList = temp;
      console.log(" this.keyWordsDto.keyLists", this.keyWordsDto.keyLists);
    },
    // async addKeys() {
    //   var api = "/manager/keyWordMatch/add";
    //   var temp = [...this.keyWordsDto.keyWords, this.keyWordsDto.keyValue];
    //   const response = await this.util.postRequest({
    //     url: api,
    //     method: "POST",
    //     data: {
    //       temp,
    //       valueId: this.keyMusic,
    //     },
    //   });
    //   if (response === "10000") {
    //     this.$message.success("关键词添加成功!");
    //     this.dialogVisible = false;
    //     this.getKeys();
    //   } else {
    //     this.$message.error(response.desc);
    //   }
    // },
    async allParameter() {
      var api = "/manager/settingConfig/selectConfigList";
      const response = await this.util.postRequest({
        url: api,
        method: "POST",
        data: {
          valueId: localStorage.getItem("keyConfigId"),
        },
      });
      this.generalLst = response.data;
      for (var i = 0; i < this.generalLst.length; i++) {
        if (this.generalLst[i].name == '快捷回复预览开关' || this.generalLst[i].name == '快捷回复默认全部展开' || this.generalLst[i].name == '按会话展示') {
          if (this.generalLst[i].jsonParamList[0].value === "1") {
            this.generalLst[i].jsonParamList[0].value = true;
            if(this.generalLst[i].name == '按会话展示'){
              this.$store.state.isShowSession = true;
            }
          }
        }
        if (this.generalLst[i].name == '快捷回复预览开关' || this.generalLst[i].name == '快捷回复默认全部展开' || this.generalLst[i].name == '按会话展示') {
          if (this.generalLst[i].jsonParamList[0].value === "0") {
            this.generalLst[i].jsonParamList[0].value = false;
            if(this.generalLst[i].name == '按会话展示'){
              this.$store.state.isShowSession = false;
            }
          }
        }
        
        // 1.已离开客户列表，展示最新离开人数
        if (this.generalLst[i].name === "已离开客户列表，展示最新离开人数") {
          for (var k = 0; k < this.generalLst[i].jsonParamList.length; k++) {
            if (this.generalLst[i].jsonParamList[k].isSelect === true) {
              this.radio = this.generalLst[i].jsonParamList[k].value;
              this.$store.state.maxLeaveNum =
                this.generalLst[i].jsonParamList[k].value;
            }
          }
        }
        // 2.回复框智能联想数据源来自
        if (this.generalLst[i].name === "回复框智能联想数据源来自") {
          var lst = [];
          this.checkList = lst;
          if (this.generalLst[i].jsonParamList.length > 0 && this.generalLst[i].jsonParamList[0].isSelect === true) {
            this.checkList.push("快捷回复库");
          }
          if (this.generalLst[i].jsonParamList.length > 1 && this.generalLst[i].jsonParamList[1].isSelect === true) {
            this.checkList.push("个人历史聊天记录");
          }
        }
        // 3.字体设置
        if (this.generalLst[i].name === "字体设置") {
          for (var t = 0; t < this.generalLst[i].jsonParamList.length; t++) {
            if (this.generalLst[i].jsonParamList[t].isSelect === true) {
              this.font = this.generalLst[i].jsonParamList[t].label;
              let value = this.generalLst[i].jsonParamList[t].value;
              localStorage.setItem("fontSize", value);
              this.$store.dispatch("changeFontSize", value);
              window.document.documentElement.setAttribute("data-size", value);
            }
          }
        }

        if (this.generalLst[i].name === "新消息提示") {
          // 新消息提示音
          for (var a = 0; a < this.generalLst[i].jsonParamList.length; a++) {
            const item = this.generalLst[i].jsonParamList[a];
            if (item.isSelect === true) {
              this.cueRadio1.name = item.label;
              localStorage.setItem("flickeraudiourl", item.value);
            }
            if (item.label === "自定义") {
              if (item.value === "") {
                this.cueRadio1.state = false;
              } else {
                this.cueRadio1.state = true;
              }
            }
          }
        } else if (this.generalLst[i].name === "新用户提示") {
          // 新用户提示
          for (let a = 0; a < this.generalLst[i].jsonParamList.length; a++) {
            if (this.generalLst[i].jsonParamList[a].isSelect === true) {
              this.cueRadio2.name = this.generalLst[i].jsonParamList[a].label;
              localStorage.setItem(
                "newaudiourl",
                this.generalLst[i].jsonParamList[a].value
              );
            }
            if (this.generalLst[i].jsonParamList[a].label === "自定义") {
              if (this.generalLst[i].jsonParamList[a].value === "") {
                this.cueRadio2.state = false;
              } else {
                this.cueRadio2.state = true;
              }
            }
          }
        } else if (this.generalLst[i].name === "关键词提示") {
          // 关键词提示音
          for (let a = 0; a < this.generalLst[i].jsonParamList.length; a++) {
            console.log("item.jsonParamList[a].label", this.generalLst[i].id);
            if (this.generalLst[i].jsonParamList[a].isSelect === true) {
              this.cueRadio3.valueId =
                this.generalLst[i].jsonParamList[a].value;
              this.keyMusic = this.generalLst[i].jsonParamList[a].id;
              this.cueRadio3.name = this.generalLst[i].jsonParamList[a].label;
              localStorage.setItem(
                "keyAudioUrl",
                this.generalLst[i].jsonParamList[a].value
              );
            }
            if (this.generalLst[i].jsonParamList[a].label === "自定义") {
              if (this.generalLst[i].jsonParamList[a].value === "") {
                this.cueRadio3.state = false;
              } else {
                this.cueRadio3.state = true;
              }
            }
          }
        } else if (this.generalLst[i].name === "音量设置") {
          for (const item of this.generalLst[i].jsonParamList) {
            if (item.isSelect === true) {
              this.volume = item.label;
              const audioList = document.querySelectorAll("audio");
              let volume = "";
              if (this.volume === "静音") {
                volume = 0;
              } else if (this.volume === "小") {
                volume = 0.25;
              } else if (this.volume === "正常") {
                volume = 0.5;
              } else if (this.volume === "大") {
                volume = 0.75;
              } else if (this.volume === "特大") {
                volume = 1;
              }
              localStorage.setItem("volume", volume);
              for (const _item of audioList) {
                _item.volume = volume;
              }
              break;
            }
          }
        }else if (this.generalLst[i].name === "快捷回复位置设置") {
          for (const item of this.generalLst[i].jsonParamList) {
            if (item.isSelect === true) {
              this.position = item.label;
              break;
            }
          }
        }else if (this.generalLst[i].name === "首次提示音") {
          // 新用户提示
          for (let a = 0; a < this.generalLst[i].jsonParamList.length; a++) {
            if (this.generalLst[i].jsonParamList[a].isSelect === true) {
              this.cueRadio4.name = this.generalLst[i].jsonParamList[a].label;
              localStorage.setItem(
                "firsturl",
                this.generalLst[i].jsonParamList[a].value
              );
            }
            if (this.generalLst[i].jsonParamList[a].label === "自定义") {
              if (this.generalLst[i].jsonParamList[a].value === "") {
                this.cueRadio4.state = false;
              } else {
                this.cueRadio4.state = true;
              }
            }
          }
        }else if (this.generalLst[i].name === "转潜提示音") {
          this.cueRadio5.id = this.generalLst[i].id;
          for (let a = 0; a < this.generalLst[i].jsonParamList.length; a++) {
            if (this.generalLst[i].jsonParamList[a].isSelect === true) {
              this.cueRadio5.name = this.generalLst[i].jsonParamList[a].label;
              localStorage.setItem(
                "changeurl",
                this.generalLst[i].jsonParamList[a].value
              );
            }
            if (this.generalLst[i].jsonParamList[a].label === "自定义") {
              if (this.generalLst[i].jsonParamList[a].value === "") {
                this.cueRadio5.state = false;
              } else {
                this.cueRadio5.state = true;
              }
            }
          }
        }else if (this.generalLst[i].name === "进度提示音") {
          this.cueRadio6.id = this.generalLst[i].id;
          for (let a = 0; a < this.generalLst[i].jsonParamList.length; a++) {
            if (this.generalLst[i].jsonParamList[a].isSelect === true) {
              this.cueRadio6.name = this.generalLst[i].jsonParamList[a].label;
              localStorage.setItem(
                "progressurl",
                this.generalLst[i].jsonParamList[a].value
              );
            }
            if (this.generalLst[i].jsonParamList[a].label === "自定义") {
              if (this.generalLst[i].jsonParamList[a].value === "") {
                this.cueRadio6.state = false;
              } else {
                this.cueRadio6.state = true;
              }
            }
          }
        }
      }
    },
    async userParameter() {
      var api = "/manager/settingConfig/selectById";
      const response = await this.util.postRequest({
        url: api,
        method: "POST",
        data: {
          userId: this.id,
        },
      });
      console.log("userParameter response = ", response.data);
      this.userLst = response.data;
      for (var i = 0; i < this.userLst.length; i++) {
        // 数据处理转换
        if (this.userLst[i].isClose == "1") {
          this.userLst[i].isClose = true;
        } else if (this.userLst[i].isClose == "0") {
          this.userLst[i].isClose = false;
        } else if (this.userLst[i].id == "5") {
          console.log(11111111111, this.userLst[i].jsonParamList);
          for (var f = 0; f < this.userLst[i].jsonParamList.length; f++) {
            console.log(2222222222222, this.userLst[i].jsonParamList[f]);
            if (this.userLst[i].jsonParamList[f].isSelect === true) {
              console.log(333333333333, this.userLst[i].jsonParamList[f].value);
              this.radio = this.userLst[i].jsonParamList[f].value;
            }
          }
          // if (this.userLst[i].isClose == '30') {
          // 	this.radio = '1';
          // } else if (this.userLst[i].isClose == '50') {
          // 	this.radio = '2';
          // } else if (this.userLst[i].isClose == '100') {
          // 	this.radio = '0';
          // }
          // console.log("处理单选框值",this.radio)
        } else if (this.userLst[i].id == "6") {
          this.checkList = [];
          var arr = this.userLst[i].isClose.split(",");
          for (var j = 0; j < arr.length; j++) {
            if (arr[j] == "1") {
              this.checkList.push("快捷回复库");
            }
            if (arr[j] == "2") {
              this.checkList.push("个人历史聊天记录");
            }
          }
          // console.log("处理多选框值",this.checkList)
        } else if (this.userLst[i].id == "7") {
          if (this.userLst[i].isClose == "10") {
            this.radio1 = "10";
          } else if (this.userLst[i].isClose == "20") {
            this.radio1 = "20";
          } else if (this.userLst[i].isClose == "30") {
            this.radio1 = "30";
          } else if (this.userLst[i].isClose == "40") {
            this.radio1 = "40";
          } else if (this.userLst[i].isClose == "50") {
            this.radio1 = "50";
          } else if (this.userLst[i].isClose == "60") {
            this.radio1 = "自定义1";
          }
          // console.log("处理音效1",this.radio1)
        } else if (this.userLst[i].id == "8") {
          if (this.userLst[i].isClose == "10") {
            this.radio2 = "10";
          } else if (this.userLst[i].isClose == "20") {
            this.radio2 = "20";
          } else if (this.userLst[i].isClose == "30") {
            this.radio2 = "30";
          } else if (this.userLst[i].isClose == "40") {
            this.radio2 = "40";
          } else if (this.userLst[i].isClose == "50") {
            this.radio2 = "50";
          } else if (this.userLst[i].isClose == "60") {
            this.radio2 = "自定义2";
          }
          // console.log("处理音效2",this.radio2)
        } else if (this.userLst[i].id == "11") {
          if (this.userLst[i].isClose == "2") {
            this.font = "正常";
          } else if (this.userLst[i].isClose == "3") {
            this.font = "大";
          } else if (this.userLst[i].isClose == "4") {
            this.font = "特大";
          }
        }
      }
      // console.log("最后的userLst值：",this.userLst)
    },
    async setParameter(id, value, url,name) {
      console.log("参数设置11111", id, value, url);
      var api = "/manager/settingConfig/save";
      const response = await this.util.postRequest({
        url: api,
        method: "POST",
        data: {
          configId: id,
          isClose: "",
          paramValue: value,
        },
      });
      console.log("*****setParameter response = *****", response.data);
      // this.userParameter()
      if (this.dealdata === true) {
        console.log("*****已进入 id*****", id);
        if (response.resultCode === "10000") {
          // this.$message.success("修改成功")
          // 更新音频缓存链接
          if (name == "新消息提示") {
            localStorage.setItem("flickeraudiourl", url);
          } else if (name == "新用户提示") {
            localStorage.setItem("newaudiourl", url);
          } else if (name == "字体设置") {
            localStorage.setItem("fontSize", value);
            window.document.documentElement.setAttribute("data-size", value);
            this.open1("设置成功");
          } else if (name == "关键词提示") {
            localStorage.setItem("keyAudioUrl", url);
          }else if (name == "首次提示音") {
            localStorage.setItem("firsturl", url);
          }else if (name == "转潜提示音") {
            localStorage.setItem("changeurl", url);
          }else if (name == "进度提示音") {
            localStorage.setItem("progressurl", url);
          }else{
            this.open1("设置成功");
          }
          this.allParameter();
        } else {
          this.open2(response.desc);
        }
      }
    },
    async colorParameter() {
      var api = "/manager/parameterSetting/color/select";
      const response = await this.util.postRequest({
        url: api,
        method: "POST",
        data: {},
      });
      console.log("colorParameterSelect response = ", response.data);
    },
    async saveParameter() {
      var api = "/manager/parameterSetting/save";
      const response = await this.util.postRequest({
        url: api,
        method: "POST",
        data: {
          // configId,
          // isClose,
          // parmaValue,
          soundeffectDTOList: [{ soundeffectId: 1, soundeffectType: 0 }],
          colorDTOList: [{ colorId: "", colorType: "" }],
          generalDTOList: [
            { parameterGeneralId: "", parameterValue: "", flag: "" },
          ],
        },
      });
      console.log("commonParameter response = ", response.data);
    },
    async selectSoundParameter() {
      var api = "/manager/parameterSetting/soundeffect/select";
      const response = await this.util.postRequest({
        url: api,
        method: "POST",
        data: {},
      });
      this.soundLst = response.data;
      console.log("selectSoundParameter response = ", response.data);
      for (var i = 0; i < this.soundLst.length; i++) {
        // console.log(11111,this.soundLst[i].title)
        if (this.soundLst[i].title === "自定义1") {
          this.selfId1 = this.soundLst[i].id;
          this.src1 = this.soundLst[i].fileUrl;
          this.state1 = true;
          this.soundLst.splice(i, 1);
          // console.log("自定义1音频链接",this.src1)
        }
        if (this.soundLst[i].title === "自定义2") {
          this.selfId2 = this.soundLst[i].id;
          this.src2 = this.soundLst[i].fileUrl;
          this.state2 = true;
          this.soundLst.splice(i, 1);
          // console.log("自定义2音频链接",this.src2)
        }
        if (this.soundLst[i].title === "无声") {
          this.soundLst.splice(i, 1);
        }
      }
      // console.log("音频参数状态",this.state1,this.state2,this.soundLst)
    },
    async editSoundParameter(id, title, url, configid, type) {
      console.log("上传音频", id, title, url, configid, type);
      var api = "/manager/parameterSetting/soundeffect/edit";
      const response = await this.util.postRequest({
        url: api,
        method: "POST",
        data: {
          id: type,
          title: title,
          fileUrl: url,
          confId: configid,
          type: type,
        },
      });
      console.log("editSoundParameter response = ", response.data);
      this.allParameter(id);
      if (response.resultCode === "10000") {
        this.audioID = "";
        this.open1("上传成功");
      } else {
        this.open2(response.desc);
      }
    },
    check1(info, fileUrl) {
      this.dealdata = true;
      console.log("新消息提示", info, fileUrl);
      if (info == "无声") {
        this.setParameter("7", "10", fileUrl);
      } else if (info == "默认音效1") {
        this.setParameter("7", "20", fileUrl);
      } else if (info == "默认音效2") {
        this.setParameter("7", "30", fileUrl);
      } else if (info == "默认音效3") {
        this.setParameter("7", "40", fileUrl);
      } else if (info == "默认音效4") {
        this.setParameter("7", "50", fileUrl);
      } else if (info == "自定义") {
        this.setParameter("7", "60", fileUrl);
      }
      // this.userParameter()
    },
    check(info, fileUrl, id,name) {
      console.log("新消息提示", info, fileUrl, name);
      if (info == "无声") {
        this.setParameter(id, "10", fileUrl, info,name);
      } else if (info == "默认音效1") {
        this.setParameter(id, "20", fileUrl, info,name);
      } else if (info == "默认音效2") {
        this.setParameter(id, "30", fileUrl, info,name);
      } else if (info == "默认音效3") {
        this.setParameter(id, "40", fileUrl, info,name);
      } else if (info == "默认音效4") {
        this.setParameter(id, "50", fileUrl, info,name);
      } else if (info == "自定义") {
        this.setParameter(id, "60", fileUrl, info,name);
      }
    },
    check2(info, fileUrl) {
      this.dealdata = true;
      console.log("新用户提示", info, fileUrl);
      if (info == "无声") {
        this.setParameter("8", "10", fileUrl);
      } else if (info == "默认音效1") {
        this.setParameter("8", "20", fileUrl);
      } else if (info == "默认音效2") {
        this.setParameter("8", "30", fileUrl);
      } else if (info == "默认音效3") {
        this.setParameter("8", "40", fileUrl);
      } else if (info == "默认音效4") {
        this.setParameter("8", "50", fileUrl);
      } else if (info == "自定义") {
        this.setParameter("8", "60", fileUrl);
      }
      // this.userParameter()
    },
    cellStyle1({ rowIndex, columnIndex }) {
      if (columnIndex == 1 && rowIndex !== 6 && rowIndex !== 7) {
        return "text-align:right;";
      } else if (
        (rowIndex == 6 && columnIndex == 1) ||
        (rowIndex == 7 && columnIndex == 1)
      ) {
        return "text-align:left;";
      } else if (this.generalLst[rowIndex].isClose === 1) {
        // console.log("uuuuuuuuuuuuuuuuuuuuuu",rowIndex)
        return "color:#b0b0b0";
      }
    },
    cellStyle2({ rowIndex, columnIndex }) {
      if (
        (rowIndex == 0 && columnIndex == 1) ||
        (rowIndex == 1 && columnIndex == 1)
      ) {
        return "text-align:right;";
      }
    },
    headerStyle1({ row, rowIndex }) {
      console.log(row, rowIndex);
      if (rowIndex == 0) {
        return "color:#000000";
      }
    },
    headerStyle2({ rowIndex, columnIndex }) {
      if (rowIndex == 0 && columnIndex == 1) {
        return "text-align:right;";
      }
    },
    clickEdit(state) {
      this.zanshiLst.type = "bgColor";
      this.zanshiLst.lst1 = this.bgMessageLst;
      this.zanshiLst.lst2 = this.bgUserLst;
      this.title = "闪烁背景配置";
      this.addbg = !this.addbg;
      this.state = state;

      // this.editSound = !this.editSound
    },
    add(num, type) {
      console.log("添加;", num, type);
      if (type == "sound") {
        this.addSound = !this.addSound;
      } else {
        this.addbg = !this.addbg;
      }
    },
    save() {
      console.log(
        "点击保存",
        this.bgvalue,
        this.colorShowLst[this.bgvalue - 1]
      );

      if (this.state == "state3") {
        this.state3 = true;
        this.zdyColor1 = this.colorShowLst[this.bgvalue - 1];
      } else {
        this.state4 = true;
        this.zdyColor2 = this.colorShowLst[this.bgvalue - 1];
      }
      this.addbg = false;
    },
    onOff(id, name, state) {
      this.dealdata = true;
    
      if (name == '快捷回复预览开关') {
        localStorage.setItem("quickPreviewSwitch", state);
      }
      if (name == '快捷回复默认全部展开') {
        localStorage.setItem("quickylySwitch", state);
      }
      var value = "";
      if (state === true) {
        value = "1";
      } else {
        value = "0";
      }
      this.setParameter(id, value);
    },
    show(index) {
      this.dealdata = true;
      // var value =  this.generalLst[index].value
      console.log("最新离开人数：", index, this.radio);
      this.setParameter(index + 1, this.radio);
      localStorage.setItem("getLeavedList", this.radio);
    },
    showFont(index) {
      this.dealdata = true;
      var font = "";
      if (this.font === "正常") {
        font = "2";
      } else if (this.font === "大") {
        font = "3";
      } else if (this.font === "特大") {
        font = "4";
      }
      console.log("字体选中大小：", font);
      this.setParameter(index + 1, font);
    },
    source(index) {
      this.dealdata = true;
      console.log("快捷回复方式：", index, this.checkList);
      var a = "";
      var b = "";
      if (this.checkList != []) {
        for (var i = 0; i < this.checkList.length; i++) {
          if (this.checkList[i] == "快捷回复库") {
            a = "1";
          }
          if (this.checkList[i] == "个人历史聊天记录") {
            b = "2";
          }
        }
      }
      // this.checkList = []
      if (a === "1" && b === "") {
        this.setParameter("6", a);
      } else if (a === "" && b === "2") {
        this.setParameter("6", b);
      } else if (a === "" && b === "") {
        this.setParameter("6", "-1");
      } else if (a === "1" && b === "2") {
        this.setParameter("6", "1,2");
      }
    },

    // beforeUpload2(file) {
    //   console.log("beforeUpload2", file);
    //   const isJPG1 = file.type === "audio/mpeg";
    //   const isLt10M2 = file.size < 1024 * 1024 * 10;
    //   if (!isJPG1) {
    //     this.$message.error("上传自定义音频只能是mp3格式!");
    //     return false;
    //   }
    //   if (!isLt10M2) {
    //     this.$message.error("上传的视频大小不能超过 10MB!");
    //     return false;
    //   }
    // },
    beforeUpload(file) {
      console.log("beforeUpload1", file, this.myHeaders, this.urlPath);
      const isJPG = file.type === "audio/mpeg";
      const isLt10M = file.size < 1024 * 1024 * 10;
      if (!isJPG) {
        this.$message.error("上传自定义音频只能是mp3格式!");
        return false;
      }
      if (!isLt10M) {
        this.$message.error("上传的音频大小不能超过 10MB!");
        return false;
      }
    },
    upSuccess(audioInfo, isClose, $index, res, file) {
      console.log("upSuccess:", audioInfo, $index, res, file);
      this.$refs.upload.clearFiles();
      if (res.resultCode === "10000") {
        var url = this.util.getLocalImgUrl() + res.data.fileUrl;
        // this.src1 = url;
        console.log("音频地址", url, $index.toString());
        // this.$message.success("视频上传成功");
        this.editSoundParameter(
          this.selfId1,
          audioInfo.label,
          url,
          ($index + 1).toString(),
          "60"
        );
        this.setParameter(($index + 1).toString(), "60", url);
      } else {
        // this.$message.error();
        this.open2("音频上传失败，请重新上传");
      }
    },

    upSuccess18(audioInfo, isClose, $index, res, file) {
      console.log("upSuccess:", audioInfo, $index, res, file);
      this.$refs.upload.clearFiles();
      if (res.resultCode === "10000") {
        var url = this.util.getLocalImgUrl() + res.data.fileUrl;
        // this.src1 = url;
        console.log("音频地址", url, $index.toString());
        // this.$message.success("视频上传成功");
        this.editSoundParameter(
          this.selfId1,
          audioInfo.label,
          url,
          '18',
          "60"
        );
        this.setParameter('18', "60", url);
      } else {
        // this.$message.error();
        this.open2("音频上传失败，请重新上传");
      }
    },

    upSuccess1(res, file) {
      console.log("upSuccess2", res, file);
      this.$refs.upload.clearFiles();
      if (res.resultCode === "10000") {
        var url = this.util.getLocalImgUrl() + res.data.fileUrl;
        console.log("音频地址", url);
        // this.$message.success("视频上传成功");
        this.editSoundParameter(this.selfId2, "自定义2", url, "8", "60");
      } else {
        this.$message.error("音频上传失败，请重新上传");
      }
    },
    playePause(idName) {
      console.log("click audio1", idName);
      var audio = document.getElementById(idName);
      console.log("audio", audio);
      if (idName !== this.audioID) {
        if (this.audioID === "") {
          // console.log("没有上一个1")
          this.audioID = idName;
          if (audio != null) {
            if (audio.paused) {
              audio.play();
            } else {
              audio.pause();
            }
          }
        } else {
          // console.log("有上一个1")
          var preAudio = document.getElementById(this.audioID);

          if (preAudio != null) {
            if (preAudio.paused) {
              preAudio.pause();
            } else {
              preAudio.pause();
            }
          }

          this.audioID = idName;
          if (audio != null) {
            if (audio.paused) {
              audio.play();
            } else {
              audio.pause();
            }
          }
        }
      } else {
        // console.log("点击自身1")
        this.audioID = idName;

        if (audio != null) {
          if (audio.paused) {
            audio.play();
          } else {
            audio.pause();
          }
        }
      }
    },
    player(configNum, id, index) {
      console.log("click audio2", id);
      if (configNum === "7") {
        this.audioIndex = index;
      } else {
        this.audioIndex1 = index;
      }
      if (configNum === "cue1") {
        this.cueRadio1.index = index;
        console.log(this.cueRadio1.index, "this.cueRadio1.index", index);
      } else if (configNum === "cue2") {
        this.cueRadio2.index = index;
      } else if (configNum === "cue3") {
        this.cueRadio3.index = index;
      }else if (configNum === "cue4") {
        this.cueRadio4.index = index;
      }
      else if (configNum === "cue5") {
        this.cueRadio5.index = index;
      }
      else if (configNum === "cue6") {
        this.cueRadio6.index = index;
      }
      this.audioClick = true;
      var audio = document.getElementById(id);
      console.log("audio", audio);
      if (id !== this.audioID) {
        if (this.audioID === "") {
          console.log("没有上一个2", this.audioID);
          this.audioID = id;
          if (audio != null) {
            if (audio.paused) {
              audio.play();
            } else {
              audio.pause();
            }
          }
        } else {
          console.log("有上一个2", this.audioID);
          var preAudio = document.getElementById(this.audioID);
          console.log(111, preAudio);
          if (preAudio != null) {
            if (preAudio.paused) {
              preAudio.pause();
            } else {
              preAudio.pause();
            }
          }

          this.audioID = id;
          if (audio != null) {
            if (audio.paused) {
              audio.play();
            } else {
              audio.pause();
            }
          }
        }
      } else {
        console.log("点击自身2====>");
        this.audioID = id;
        if (audio != null) {
          if (audio.paused) {
            audio.play();
          } else {
            audio.pause();
          }
        }
      }
    },

    // setVol(configNum, id, index){

    // },

    open1(info) {
      console.log(info);
      const tipMsg = "设置成功";
      this.$message.success(tipMsg);
    },
    open2(info) {
      const text = info + " 保存失败 ";
      this.$message.error(text);
    },
    playing() {
      if (this.audioClick === false) {
        this.audioState = false;
      } else {
        this.audioState = true;
      }
    },
    ended() {
      this.audioState = false;
      this.audioIndex = "";
      this.audioIndex1 = "";
      this.cueRadio1.index = "";
      this.cueRadio2.index = "";
      this.cueRadio3.index = "";
      this.cueRadio4.index = "";
      this.cueRadio5.index = "";
      this.cueRadio6.index = "";
    },
    // 隐藏不能修改的标签
    tableRowClassName1({ row }) {
      // console.log("关闭第一组：", row.isClose == 1 || row.groupId == "2", row);
      if (row.isClose == 1 || row.groupId == "2") {
        return "hidden_box";
      } else {
        return "";
      }
    },
    tableRowClassName2({ row }) {
      if (row.isClose == 1 || row.groupId == "1") {
        // console.log("关闭第二组，第一项");
        return "hidden_box";
      } else {
        return "";
      }
    },
  },
};
</script>

<style scoped="scoped" lang="scss">
.el-checkbox-group {
  font-size: inherit;
}
.dialog {
  height: 400px;
}
::v-deep  .el-table th.el-table__cell {
  &::before {
    display: none;
  }
  & > .cell {
    padding-left: 0;
  }
}
.el-dialog__title::before {
  display: block;
  content: "";
  width: 3px;
  height: auto;
  background-color: #1577d2;
  margin-right: 6px;
}
::v-deep  .el-dialog-crucial {
  .el-dialog__body {
    padding: 2px 20px 10px;
  }
  .el-textarea {
    margin-top: 12px;
  }
}
.el-dialog__cue {
  color: #999999;
}
.el-dialog__title {
  display: flex;
  color: #333;
  font-weight: 600;
  line-height: 1;
}
// .el-table__row > .el-table_cell

:deep() .beforeStyle {
  &::before {
    display: inline-block;
    content: "";
    min-width: 3px;
    height: 0.9em;
    position: absolute;
    top: calc(50% - 0.45em);
    background-color: #1577d2;
    vertical-align: middle;
    left: 0;
  }
}
.tipBeforeStyle {
  position: relative;
  @extend .beforeStyle;
  &::before {
    left: -10px;
  }
}

.Rcell {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: wrap;
}

.rdo {
  display: flex;
  /* margin-left: 15px; */
}

.item {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
}

.cgcolor:hover {
  color: #55aaff;
}
.colorShow {
  width: 15px;
  height: 15px;
}

.el-table--border::after,
.el-table--group::after,
.el-table::before {
  content: none;
}

.el-table .hidden_box {
  display: none;
}
</style>
